import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './firebase'

const container = document.getElementById('root')
const appTree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, appTree)
} else {
  const root = ReactDOM.createRoot(container)
  root.render(appTree)
}

const bootLoader = document.getElementById('boot-loader')
if (bootLoader) {
  requestAnimationFrame(() => {
    bootLoader.classList.add('hidden')
    setTimeout(() => bootLoader.remove(), 300)
  })
}

// FCM service worker registration removed — using Appwrite backend
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/firebase-messaging-sw.js')
// }
